import countries from './countries.es';
import streetTypes from './street-types.es';
import intervenerRoles from './intervenerRoles';
import maritalStatuses from './maritalStatuses';
import documents from './documents.es';
import operations from './operations.es';
import notifications from './notifications.es';
import interveners from './interveners.es';
import headers from './headers.es';
import kyc from './kyc.es';
import spanishProvinces from './spanish-provinces.es';
import accounts from './accounts.es';
import convenience from './convenience.es';

export default {
    accounts,
    countries,
    streetTypes,
    intervenerRoles,
    maritalStatuses,
    documents,
    operations,
    notifications,
    interveners,
    headers,
    kyc,
    spanishProvinces,
    convenience
};
